import type { ThemeMode } from '@store/appConfig/types';
import type { ColorsMap, IPaletteThemeProperties } from '@themes/types/theme';

import { getColorsTree } from '@themes/utils/getColorsTree';

const DefaultTheme = (mode: ThemeMode): IPaletteThemeProperties => {
  const colorsMap: ColorsMap = {
    contrastText: {
      dark: ['#fff'],
      light: ['#fff'],
    },
    contrastBackground: {
      light: ['#fff'],
      dark: ['#141414'],
    },
    warning: {
      dark: ['#342c1a', '#836611', '#dda705', '#e9bf28', '#f8e577'],
      light: ['#FFF7E0', '#FFC926', '#FFBF00', '#FFB900', '#FFA900'],
    },
    success: {
      dark: ['#1a2721', '#115c36', '#05934c', '#1da65d', '#61ca8b'],
      light: ['#E0F5EA', '#26B56E', '#00A854', '#00A04D', '#008D3A'],
    },
    info: {
      dark: ['#1a2628', '#11595f', '#058e98', '#1ea6aa', '#64cfcb', '#004BB7'],
      light: ['#E0F4F5', '#26B0BA', '#00A2AE', '#009AA7', '#008694', '#004BB7'],
    },
    error: {
      dark: [
        '#fde6e5',
        '#f9c1bd',
        '#f69891',
        '#f26f65',
        '#ef5044',
        '#ec3123',
        '#ea2c1f',
        '#e7251a',
        '#e41f15',
        '#df130c',
      ],
      light: [
        '#fde6e5',
        '#f9c1bd',
        '#f69891',
        '#f26f65',
        '#ef5044',
        '#ec3123',
        '#ea2c1f',
        '#e7251a',
        '#e41f15',
        '#df130c',
      ],
    },
    primary: {
      dark: [
        '#32221a',
        '#f2d1b9',
        '#e9b28a',
        '#e0935b',
        '#d97b38',
        '#d26415',
        '#cd5c12',
        '#c7520f',
        '#c1480c',
        '#b63606',
      ],
      light: [
        '#fff6e3',
        '#fee9b9',
        '#fdda8a',
        '#fccb5b',
        '#fcbf37',
        '#f6901d',
        '#f6901d',
        '#faa40e',
        '#f99c0b',
        '#f88c06',
      ],
    },
  };

  return getColorsTree({
    mode,
    colorsMap,
  });
};

export default DefaultTheme;
